<template>
  <div>
    <h5 style="text-decoration: underline;">Know Your Gateway</h5>
    <h2>{{gateway.name}}</h2>

    <div>
      <span v-if="gateway.tags"><b>Tags</b>:</span>

      <span v-for="(tag,index) in gateway.tags" v-bind:key="tag">
        {{tag}}<template v-if="index != (gateway.tags.length - 1)">,</template>
      </span>
    </div>

    <hr/>

    <table style="width: 100%">
      <tr v-if="!!gateway.homepage">
        <td><b>Homepage</b>:</td>
        <td><a v-bind:href="gateway.homepage">{{gateway.homepage}}</a></td>
      </tr>

      <tr>
        <td><b>Addresses</b>:</td>
        <td>
          <ul>
            <li v-for="address in gateway.addresses" v-bind:key="address">
              <AccountLink v-bind:account="address" no_tag />
            </li>
          </ul>
        </td>
      </tr>

      <tr v-if="!!gateway.founded">
        <td><b>Founded</b>:</td>
        <td>{{gateway.founded}}</td>
      </tr>

      <tr v-if="!!gateway.individuals">
        <td><b>Associated Individuals</b>:</td>
        <td>
          <ul>
            <li v-for="(name,title) in gateway.individuals" v-bind:key="name">
              {{name}} ({{title}})
            </li>
          </ul>
        </td>
      </tr>

      <tr v-if="!!gateway.emails || !!gateway.phone_numbers">
        <td><b>Contact Info</b>:</td>

        <td>
          <ul>
            <li v-for="(email,index) in gateway.emails" v-bind:key="'email' + index">
              <a v-bind:href="'mailto:' + email">{{email}}</a>
            </li>

            <li v-for="(phone,index) in gateway.phone_numbers" v-bind:key="'phone' + index">
              {{phone}}
            </li>
          </ul>
        </td>
      </tr>

      <tr v-if="gateway.headquarters">
        <td><b>Headquarters</b>:</td>
        <td>
          <div v-for="(hq,index) in gateway.headquarters" v-bind:key="index">
            {{hq}}
          </div>
        </td>
      </tr>

      <tr v-if="!!gateway.other_locations">
        <td><b>Other Addresses</b>:</td>
        <td>
          <ul>
            <li v-for="(address,desc) in gateway.other_locations" v-bind:key="desc"
                style="margin-bottom: 15px">
              <i style="text-decoration: underline">{{desc}}</i>:
              <ul>
                <li v-for="(addr,index) in address" v-bind:key="index">
                  {{addr}}
                </li>
              </ul>
            </li>
          </ul>
        </td>
      </tr>

      <tr>
        <td><b>Overview</b>:</td>
        <td>
          <div v-for="(txt,index) in gateway.description" v-bind:key="index">
            {{txt}}<br/><br/>
          </div>
        </td>
      </tr>

      <tr v-if="!!gateway.links">
        <td><b>Links</b>:</td>
        <td>
          <ul>
            <li v-for="link in gateway.links" v-bind:key="link">
              <a v-bind:href="link">{{link | ellipsis(50)}}</a>
            </li>
          </ul>
        </td>
      </tr>

      <!-- TODO activation history (use existing widget?) -->
    </table>
  </div>
</template>

<script>
import AccountLink from './AccountLink.vue'

export default {
  name: 'KnowYourGateway',

  props : {
    gateway : Object
  },

  components : {
    AccountLink,
  }
}
</script>

<style scoped>
ul{
  margin-bottom: 0;
  padding-left: 0;
  list-style-type: none;
}

tr{
  border-bottom: 1px solid black;
}

tr:last-of-type{
  border-bottom: none;
}

td{
  vertical-align: top;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
